(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-preventa-demon-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-bpdemon]'); if(!root) return;
  var track=root.querySelector('[data-bpdemon-track]'); if(!track) return;
  var reduce=false; try{reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;}catch(e){}
  function dur(){ if(reduce) return; var half=track.scrollWidth/2; if(half>0) track.style.animationDuration=(half/75).toFixed(1)+'s'; }
  if(document.readyState!=='loading') dur(); else document.addEventListener('DOMContentLoaded',dur);
  window.addEventListener('load',dur);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(dur);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-cierre-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var a=document.querySelector('[data-crof47-cta]'); if(!a||a.__crof) return; a.__crof=1;
  a.addEventListener('click',function(e){
    var h=a.getAttribute('href')||'';
    if(h.charAt(0)==='#'){ var t=document.querySelector(h); if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); } }
    if(window.CRO47) window.CRO47.track('select_item',{ from:'cierre_cta' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-hero-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-croh47]'); if (!root || root.__croh) return; root.__croh = 1;

  /* Video del hero: preload none + arranque en idle. Nunca compite con el LCP. */
  var v = root.querySelector('[data-croh47-vid]');
  if (v) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce) { v.removeAttribute('src'); v.innerHTML = ''; }
    else {
      var go = function(){
        v.preload = 'auto'; v.load();
        var p = v.play && v.play(); if (p && p.catch) p.catch(function(){});
      };
      var kick = function(){ ('requestIdleCallback' in window) ? requestIdleCallback(go, {timeout:1500}) : setTimeout(go, 800); };
      (document.readyState === 'complete') ? kick() : window.addEventListener('load', kick, {once:true});
    }
  }

  /* CTA del hero: baja al selector y avisa al tracking. */
  var cta = root.querySelector('[data-croh47-cta]');
  if (cta) {
    cta.addEventListener('click', function(e){
      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        var t = document.querySelector(href);
        if (t) { e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
      }
      if (window.CRO47) window.CRO47.track('select_item', { from: 'hero_cta' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-media-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-crom47]'); if(!root||root.__crom) return; root.__crom=1;
  var v=root.querySelector('[data-crom47-vid]'); if(!v) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches){ v.removeAttribute('src'); v.innerHTML=''; return; }
  var started=false;
  function start(){
    if(started) return; started=true;
    v.preload='auto'; v.load();
    var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      en.forEach(function(x){
        if(x.isIntersecting){ start(); var q=v.play&&v.play(); if(q&&q.catch) q.catch(function(){}); }
        else if(started){ v.pause&&v.pause(); }
      });
    },{threshold:.3});
    io.observe(v);
  } else {
    window.addEventListener('load', start, {once:true});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-selector-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-crosel]');
  if (!root || root.__crosel) return; root.__crosel = 1;

  var CFG        = (window.CRO47 && window.CRO47.cfg) || {};
  var mode       = root.dataset.mode === 'inherit' ? (CFG.offer_mode || 'single_product') : root.dataset.mode;
  var target     = parseInt(root.dataset.target, 10) || 0;
  var allowDupes = root.dataset.allowDupes === 'true';
  var SKEY       = 'cro47_sel_' + (root.dataset.offer || 'x');
  var needsCount = (mode === 'build_your_bundle');

  var $ = function(sel){ return root.querySelector(sel); };
  var cta      = $('[data-crosel-buy]');
  var btnText  = $('[data-crosel-btntext]');
  var errBox   = $('[data-crosel-err]');
  var sumBox   = $('[data-crosel-summary]');
  var sumList  = $('[data-crosel-sumlist]');
  var sumTotal = $('[data-crosel-total]');
  var progBox  = $('[data-crosel-prog]');
  var sticky   = $('[data-crosel-sticky]');
  var stickyBtn= $('[data-crosel-stickybtn]');
  var stickyPr = $('[data-crosel-stickyprice]');

  /* ── estado ───────────────────────────────────────────────────────────────── */
  var picks = [];   /* [{variant, name, vtitle, price, img, productId}] */

  function money(cents){
    try { return new Intl.NumberFormat('es-MX', {style:'currency', currency: CFG.currency || 'MXN', maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return '$' + Math.round(cents/100).toLocaleString('es-MX'); }
  }
  function total(){ return picks.reduce(function(a,p){ return a + (p.price||0); }, 0); }

  function save(){ try { sessionStorage.setItem(SKEY, JSON.stringify(picks)); } catch(e){} }
  function restore(){
    try {
      var raw = sessionStorage.getItem(SKEY); if (!raw) return;
      var arr = JSON.parse(raw); if (!Array.isArray(arr)) return;
      /* solo se restauran variantes que siguen existiendo y disponibles en el DOM */
      picks = arr.filter(function(p){
        return root.querySelector('[data-variant="' + p.variant + '"]:not([disabled])')
            || root.querySelector('input[name="crosel-variant"][value="' + p.variant + '"]:not([disabled])');
      });
      picks.forEach(function(p){ paintPick(p); });
    } catch(e){}
  }
  function paintPick(p){
    var b = root.querySelector('[data-variant="' + p.variant + '"]');
    if (b) { b.classList.add('is-on'); var card = b.closest('[data-crosel-card]'); if (card) card.classList.add('is-picked'); }
    var r = root.querySelector('input[name="crosel-variant"][value="' + p.variant + '"]');
    if (r) r.checked = true;
  }

  /* ── UI ───────────────────────────────────────────────────────────────────── */
  function showErr(msg){
    if (!errBox) return;
    if (!msg) { errBox.hidden = true; errBox.textContent = ''; return; }
    errBox.hidden = false; errBox.textContent = msg;
  }

  function render(){
    var n = picks.length;
    var done = needsCount ? (n >= target) : (n > 0);

    if (progBox && needsCount) {
      progBox.hidden = false;
      var cEl = $('[data-crosel-count]'), fEl = $('[data-crosel-fill]'), mEl = $('[data-crosel-msg]');
      if (cEl) cEl.textContent = n;
      if (fEl) fEl.style.width = Math.min(100, (n / target) * 100) + '%';
      if (mEl) mEl.textContent = done ? 'Listo, ya puedes continuar'
                                      : 'Te falta' + ((target - n) === 1 ? ' 1 pieza' : 'n ' + (target - n) + ' piezas');
    }

    if (sumBox) {
      sumBox.hidden = n === 0;
      if (sumList) {
        sumList.innerHTML = '';
        picks.forEach(function(p, i){
          var li = document.createElement('li');
          li.className = 'crosel47__sum-item';
          li.innerHTML =
            (p.img ? '<img src="' + p.img + '" alt="" width="38" height="48" loading="lazy">' : '') +
            '<span class="crosel47__sum-t"><span class="crosel47__sum-n"></span><span class="crosel47__sum-v"></span></span>' +
            '<button type="button" class="crosel47__sum-x" aria-label="Quitar">×</button>';
          li.querySelector('.crosel47__sum-n').textContent = p.name || '';
          li.querySelector('.crosel47__sum-v').textContent = (p.vtitle || '') + ' · ' + money(p.price || 0);
          li.querySelector('.crosel47__sum-x').addEventListener('click', function(){ removeAt(i); });
          sumList.appendChild(li);
        });
      }
      if (sumTotal) sumTotal.textContent = money(total());
    }

    if (cta) {
      cta.disabled = !done;
      cta.setAttribute('aria-disabled', String(!done));
      if (btnText) {
        btnText.textContent = done
          ? (root.dataset.ctaReady || cta.dataset.ready || 'CONTINUAR') + (n ? ' · ' + money(total()) : '')
          : (needsCount ? 'ELIGE ' + target + ' PIEZAS' : 'ELIGE TU TALLA');
      }
    }
    if (stickyBtn) stickyBtn.disabled = !done;
    if (stickyPr)  stickyPr.textContent = n ? money(total()) : '—';

    save();
    if (window.CRO47 && needsCount) window.CRO47.track('bundle_progress', { bundle_size: target, selected: n });
  }

  function removeAt(i){
    var p = picks[i]; if (!p) return;
    picks.splice(i, 1);
    var b = root.querySelector('[data-variant="' + p.variant + '"]');
    if (b) {
      var still = picks.some(function(x){ return x.variant === p.variant; });
      if (!still) {
        b.classList.remove('is-on');
        var card = b.closest('[data-crosel-card]');
        if (card && !picks.some(function(x){ return x.productId === p.productId; })) card.classList.remove('is-picked');
      }
    }
    showErr(''); render();
  }

  /* ── producto único / pack ────────────────────────────────────────────────── */
  var sizes = $('[data-crosel-sizes]');
  if (sizes) {
    sizes.addEventListener('change', function(e){
      var r = e.target; if (!r || r.name !== 'crosel-variant') return;
      var single = $('[data-crosel-single]');
      picks = [{
        variant: r.value,
        name: single ? (single.querySelector('.crosel47__single-name')||{}).textContent : '',
        vtitle: r.dataset.title || '',
        price: parseInt(r.dataset.price, 10) || 0,
        img: single ? ((single.querySelector('img')||{}).src || '') : '',
        productId: single ? single.dataset.productId : ''
      }];
      showErr('');
      if (window.CRO47) window.CRO47.track('select_size', { variant_id: r.value });
      render();
    });
  }
  var one = $('[data-crosel-onevariant]');
  if (one) {
    var sg = $('[data-crosel-single]');
    picks = [{ variant: one.value, name: sg ? (sg.querySelector('.crosel47__single-name')||{}).textContent : '',
               vtitle: '', price: 0, img: '', productId: sg ? sg.dataset.productId : '' }];
  }

  /* ── grid: elegir talla = elegir pieza ────────────────────────────────────── */
  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-variant]'); if (!b || b.disabled) return;
    var card = b.closest('[data-crosel-card]'); if (!card) return;

    var idx = picks.findIndex(function(p){ return p.variant === b.dataset.variant; });
    if (idx >= 0) { removeAt(idx); return; }              /* segundo toque = quitar */

    if (needsCount && picks.length >= target) {
      showErr('Ya elegiste ' + target + ' piezas. Quita una del resumen si quieres cambiarla.');
      return;
    }
    if (!allowDupes && picks.some(function(p){ return p.productId === card.dataset.productId; })) {
      showErr('Ya tienes ese diseño. Toca de nuevo su talla para quitarlo, o activa repetidos.');
      return;
    }
    /* una talla por tarjeta: si ya había otra talla del mismo diseño, se reemplaza */
    card.querySelectorAll('[data-variant].is-on').forEach(function(x){ x.classList.remove('is-on'); });

    picks.push({
      variant: b.dataset.variant,
      name: card.dataset.name || '',
      vtitle: b.dataset.vtitle || '',
      price: parseInt(b.dataset.vprice, 10) || 0,
      img: card.dataset.img || '',
      productId: card.dataset.productId || ''
    });
    b.classList.add('is-on'); card.classList.add('is-picked');
    showErr('');
    if (window.CRO47) window.CRO47.track('select_item', { variant_id: b.dataset.variant });
    render();
  });

  /* ── filtros ──────────────────────────────────────────────────────────────── */
  var filters = $('[data-crosel-filters]');
  if (filters) {
    filters.addEventListener('click', function(e){
      var f = e.target.closest('[data-filter]'); if (!f) return;
      filters.querySelectorAll('[data-filter]').forEach(function(x){ x.classList.remove('is-on'); });
      f.classList.add('is-on');
      var t = f.dataset.filter;
      root.querySelectorAll('[data-crosel-card]').forEach(function(c){
        c.classList.toggle('is-hidden', t !== '*' && (c.dataset.tags || '').indexOf(t) === -1);
      });
    });
  }

  /* ── agregar al carrito · atómico y sin doble clic ────────────────────────── */
  var busy = false;
  function buy(){
    if (busy) return;
    var done = needsCount ? (picks.length >= target) : (picks.length > 0);
    if (!done) { showErr(needsCount ? 'Te faltan piezas por elegir' : 'Elige tu talla para continuar'); return; }

    busy = true;
    if (cta) { cta.classList.add('is-busy'); cta.disabled = true; }
    if (stickyBtn) stickyBtn.disabled = true;
    showErr('');

    /* Un solo POST con todo: o entra el pack completo o no entra nada. */
    var body = {
      items: picks.map(function(p){ return { id: Number(p.variant), quantity: 1 }; })
    };
    if (window.CRO47) body.attributes = window.CRO47.cartAttributes();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, data: j }; }); })
    .then(function(res){
      if (!res.ok) {
        var msg = (res.data && (res.data.description || res.data.message)) || 'No pudimos agregar tu selección';
        throw new Error(msg);
      }
      if (window.CRO47) {
        window.CRO47.track('add_to_cart', {
          value: total()/100, quantity: picks.length,
          bundle_size: needsCount ? target : picks.length
        });
        window.CRO47.track('begin_checkout', { value: total()/100 });
      }
      try { sessionStorage.removeItem(SKEY); } catch(e){}
      var m = CFG.cart_mode || 'checkout';
      if (m === 'drawer' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('cart47:open'));
        busy = false; if (cta) { cta.classList.remove('is-busy'); } render();
      } else {
        window.location.href = (m === 'cart') ? '/cart' : (CFG.return_url || '/checkout');
      }
    })
    .catch(function(err){
      busy = false;
      if (cta) { cta.classList.remove('is-busy'); cta.disabled = false; }
      if (stickyBtn) stickyBtn.disabled = false;
      showErr(err.message || 'Algo falló. Vuelve a intentar o escríbenos por WhatsApp');
    });
  }
  if (cta) cta.addEventListener('click', buy);
  if (stickyBtn) stickyBtn.addEventListener('click', function(){
    if (stickyBtn.disabled) { root.scrollIntoView({behavior:'smooth', block:'center'}); return; }
    buy();
  });

  /* sticky visible cuando el CTA principal sale de pantalla */
  if (sticky && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(en){
      en.forEach(function(x){
        sticky.classList.toggle('is-show', !x.isIntersecting);
        sticky.setAttribute('aria-hidden', x.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '0px 0px -20% 0px' }).observe(cta);
  }

  restore();
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deja-tu-resena-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.revInit==='1') return; root.dataset.revInit='1';
    var form=root.querySelector('[data-rev47-form]');
    var starsWrap=root.querySelector('[data-rev47-stars]');
    var stars=[].slice.call(root.querySelectorAll('.rev47__star'));
    var starMsg=root.querySelector('[data-rev47-starmsg]');
    var body=root.querySelector('[data-rev47-body]');
    var lenEl=root.querySelector('[data-rev47-len]');
    var nameEl=root.querySelector('[data-rev47-name]');
    var fileEl=root.querySelector('[data-rev47-file]');
    var drop=root.querySelector('[data-rev47-drop]');
    var previews=root.querySelector('[data-rev47-previews]');
    var submit=root.querySelector('[data-rev47-submit]');
    var btnLabel=root.querySelector('[data-rev47-btnlabel]');
    var doneBox=root.querySelector('[data-rev47-done]');
    var errBox=root.querySelector('[data-rev47-err]');
    var maxPhotos=parseInt(root.getAttribute('data-maxphotos'),10)||3;
    var endpoint=(root.getAttribute('data-endpoint')||'').trim();
    var urlKw=''; try{ urlKw=(new URLSearchParams(location.search)).get('kw')||''; }catch(e){}
    var KW=((root.getAttribute('data-keywords')||'').trim())||urlKw;
    var maxEl=root.querySelector('[data-rev47-max]'); if(maxEl) maxEl.textContent=maxPhotos;
    var LABELS=['','No me latió','Regular','Buena','Muy buena','Brutal'];
    var rating=0, photos=[]; // photos: {blob, url}

    function validate(){ submit.disabled=!(rating>0 && body.value.trim().length>=3); }

    // estrellas
    stars.forEach(function(st){
      var v=parseInt(st.getAttribute('data-val'),10);
      st.addEventListener('click', function(){ setRating(v); });
      st.addEventListener('mouseenter', function(){ paint(v); });
    });
    starsWrap.addEventListener('mouseleave', function(){ paint(rating); });
    function paint(n){ stars.forEach(function(st,i){ st.classList.toggle('is-on', i<n); }); }
    function setRating(v){ rating=v; paint(v); stars.forEach(function(st,i){ st.setAttribute('aria-checked', i===v-1?'true':'false'); });
      starMsg.textContent=LABELS[v]||''; starMsg.classList.add('is-show'); validate(); }

    // texto
    body.addEventListener('input', function(){ lenEl.textContent=body.value.length; validate(); });

    // fotos
    drop.addEventListener('click', function(e){ if(e.target!==fileEl) fileEl.click(); });
    fileEl.addEventListener('change', function(){ var fs=[].slice.call(fileEl.files||[]); fileEl.value=''; fs.forEach(addPhoto); });
    function slotsLeft(){ return maxPhotos - photos.length; }
    function refreshDrop(){ drop.classList.toggle('is-full', slotsLeft()<=0); }
    function addPhoto(file){
      if(!/^image\//.test(file.type) || slotsLeft()<=0) return;
      var ph={blob:null,url:null,ready:null}; var _rdy; ph.ready=new Promise(function(r){ _rdy=r; });
      var thumb=document.createElement('div'); thumb.className='rev47__thumb is-load';
      var img=document.createElement('img'); thumb.appendChild(img);
      var rm=document.createElement('button'); rm.type='button'; rm.setAttribute('aria-label','Quitar foto'); rm.innerHTML='&times;'; thumb.appendChild(rm);
      previews.appendChild(thumb); photos.push(ph); refreshDrop();
      rm.addEventListener('click', function(){ var idx=photos.indexOf(ph); if(idx>-1) photos.splice(idx,1); if(ph.url) URL.revokeObjectURL(ph.url); thumb.parentNode.removeChild(thumb); refreshDrop(); });
      compress(file, function(blob, url){ ph.blob=blob; ph.url=url; img.src=url; thumb.classList.remove('is-load'); if(_rdy) _rdy(); });
    }
    function compress(file, cb){
      var url=URL.createObjectURL(file); var im=new Image();
      im.onload=function(){ var max=1280,w=im.width,h=im.height;
        if(w>h && w>max){ h=Math.round(h*max/w); w=max; } else if(h>=w && h>max){ w=Math.round(w*max/h); h=max; }
        var c=document.createElement('canvas'); c.width=w; c.height=h; c.getContext('2d').drawImage(im,0,0,w,h);
        c.toBlob(function(b){ URL.revokeObjectURL(url); cb(b||file, URL.createObjectURL(b||file)); }, 'image/jpeg', 0.82);
      };
      im.onerror=function(){ cb(file, url); };
      im.src=url;
    }

    // dedupe simple por sesión/día
    function alreadySent(){ try{ return localStorage.getItem('rev47_sent')===new Date().toDateString(); }catch(e){ return false; } }
    function markSent(){ try{ localStorage.setItem('rev47_sent', new Date().toDateString()); }catch(e){} }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(submit.disabled) return;
      errBox.hidden=true;
      submit.classList.add('is-loading'); submit.disabled=true;
      btnLabel.textContent = photos.length ? 'Optimizando fotos...' : 'Enviando...';
      Promise.all(photos.map(function(p){ return p.ready || Promise.resolve(); })).then(function(){
      btnLabel.textContent='Enviando...';
      var fd=new FormData();
      fd.append('rating', String(rating));
      fd.append('body', body.value.trim());
      fd.append('name', (nameEl.value||'').trim());
      fd.append('source','47x-web'); fd.append('page', location.pathname); fd.append('keywords', KW);
      photos.forEach(function(p,i){ if(p.blob) fd.append('photos[]', p.blob, 'resena-'+(i+1)+'.jpg'); });

      function ok(){ markSent(); form.querySelectorAll('.rev47__q,.rev47__stars,.rev47__ta,.rev47__count,.rev47__photos,.rev47__drop,.rev47__in,.rev47__submit,.rev47__legal').forEach(function(el){ el.style.display='none'; });
        doneBox.querySelector('[data-rev47-done-t]').textContent=root.getAttribute('data-thanks-title');
        doneBox.querySelector('[data-rev47-done-x]').textContent=root.getAttribute('data-thanks-text');
        doneBox.hidden=false; }
      function fail(){ submit.classList.remove('is-loading'); submit.disabled=false; btnLabel.textContent='Publicar mi reseña'; errBox.hidden=false; }

      if(!endpoint){ // sin backend aún: no rompe, guarda local y agradece
        try{ var q=JSON.parse(localStorage.getItem('rev47_queue')||'[]'); q.push({rating:rating, body:body.value.trim(), name:nameEl.value.trim(), at:Date.now()}); localStorage.setItem('rev47_queue', JSON.stringify(q)); }catch(e){}
        console.warn('[rev47] Sin endpoint configurado: reseña guardada localmente. Configura submit_url en el editor.');
        setTimeout(ok, 500); return;
      }
      fetch(endpoint, { method:'POST', body:fd })
        .then(function(r){ if(!r.ok) throw 0; return ok(); })
        .catch(fail);
      });
    });

    validate();
  }
  var nodes=document.querySelectorAll('.rev47'); for(var i=0;i<nodes.length;i++) init(nodes[i]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-ds-landing-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.dsl47'); if(!root) return;
  var bar=root.querySelector('[data-dsl-bar]');
  var cntEl=bar?bar.querySelector('[data-dsl-count]'):null;
  var totEl=bar?bar.querySelector('[data-dsl-total]'):null;

  function money(cents){ return '$'+(cents/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function updateBar(){
    if(!bar) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      if(c && c.item_count>0){ bar.hidden=false; if(cntEl)cntEl.textContent=c.item_count; if(totEl)totEl.textContent=money(c.total_price); }
      else { bar.hidden=true; }
    }).catch(function(){});
  }

  root.querySelectorAll('[data-dsl-card]').forEach(function(card){
    var variants=[]; try{ variants=JSON.parse(card.getAttribute('data-variants')||'[]'); }catch(e){}
    var addBtn=card.querySelector('[data-dsl-add]'); if(!addBtn) return;

    function ov(v,oi){ return oi==='1'?v.o1:(oi==='2'?v.o2:v.o3); }
    function selectedVals(){ var s={}; card.querySelectorAll('.dsl47c__pill.is-sel').forEach(function(p){ s[p.getAttribute('data-oi')]=p.getAttribute('data-val'); }); return s; }
    function resolve(){
      var s=selectedVals();
      for(var i=0;i<variants.length;i++){ var v=variants[i];
        if((s['1']==null||v.o1===s['1']) && (s['2']==null||v.o2===s['2']) && (s['3']==null||v.o3===s['3'])) return v;
      }
      return null;
    }
    function pillOk(pill){
      var oi=pill.getAttribute('data-oi'), val=pill.getAttribute('data-val'), s=selectedVals();
      for(var i=0;i<variants.length;i++){ var v=variants[i]; if(!v.a) continue; if(ov(v,oi)!==val) continue;
        var ok=true; ['1','2','3'].forEach(function(k){ if(k!==oi && s[k]!=null && ov(v,k)!==s[k]) ok=false; }); if(ok) return true; }
      return false;
    }
    function updatePills(){ card.querySelectorAll('.dsl47c__pill').forEach(function(pill){ if(pillOk(pill)) pill.classList.remove('is-out'); else pill.classList.add('is-out'); }); }
    function refresh(){
      var v=resolve();
      if(v && v.a){ addBtn.disabled=false; addBtn._vid=v.id; if(!addBtn.classList.contains('is-added')) addBtn.textContent='AGREGAR'; }
      else { addBtn.disabled=true; addBtn._vid=null; addBtn.textContent=v?'AGOTADO':'ELIGE TALLA'; }
      updatePills();
    }

    // preseleccionar la primera variante DISPONIBLE (no la primera talla a secas)
    (function(){ var fav=null; for(var i=0;i<variants.length;i++){ if(variants[i].a){ fav=variants[i]; break; } }
      if(fav){ card.querySelectorAll('.dsl47c__pill').forEach(function(pill){ var oi=pill.getAttribute('data-oi'); if(ov(fav,oi)===pill.getAttribute('data-val')) pill.classList.add('is-sel'); else pill.classList.remove('is-sel'); }); } })();

    card.querySelectorAll('.dsl47c__pill').forEach(function(pill){
      pill.addEventListener('click',function(){
        if(pill.classList.contains('is-out')) return;
        var oi=pill.getAttribute('data-oi');
        card.querySelectorAll('.dsl47c__pill[data-oi="'+oi+'"]').forEach(function(x){ x.classList.remove('is-sel'); });
        pill.classList.add('is-sel'); refresh();
      });
    });

    addBtn.addEventListener('click',function(){
      var vid=addBtn._vid; if(!vid) return;
      addBtn.textContent='...'; addBtn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
        .then(function(r){return r.json();})
        .then(function(){ addBtn.textContent='✓ AGREGADO'; addBtn.classList.add('is-added'); addBtn.disabled=false; updateBar();
          setTimeout(function(){ addBtn.classList.remove('is-added'); refresh(); },1500); })
        .catch(function(){ addBtn.disabled=false; refresh(); });
    });

    refresh();
  });

  updateBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-onepiece-landing-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.op47'); if(!root) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var els=root.querySelectorAll('.op47__rv'); if(!els.length) return;
  if(!('IntersectionObserver' in window)){ for(var i=0;i<els.length;i++) els[i].classList.add('op47__rv--in'); return; }
  var io=new IntersectionObserver(function(en){ for(var i=0;i<en.length;i++){ if(en[i].isIntersecting){ en[i].target.classList.add('op47__rv--in'); io.unobserve(en[i].target); } } },{ rootMargin:'0px 0px -8% 0px', threshold:0.06 });
  for(var j=0;j<els.length;j++) io.observe(els[j]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-beneficios-47x"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hben47__grid').forEach(function (grid) {
    var n = grid.querySelectorAll('.hben47__item').length;
    if (n) grid.style.setProperty('--hben47-cols', Math.min(n, 4));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-confianza-47x"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.hconf47--reveal');
  var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches
    || ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (sec) {
    if (coarse || reduce || !('IntersectionObserver' in window)) {
      sec.classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mujer47x-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mj47h]'); if(!root||root.__mj47h) return; root.__mj47h=1;

  /* fondo en video · nunca compite con el LCP */
  var v=root.querySelector('[data-mj47h-vid]');
  if(v){
    var deskOnly=v.getAttribute('data-deskonly')==='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduce||(deskOnly&&window.matchMedia&&window.matchMedia('(max-width:899px)').matches)){
      v.removeAttribute('src'); v.innerHTML='';
    } else {
      /* 47X · esta seccion ya NO arranca el fondo por su cuenta (3-sep-2026).
         Mismo patron que traia Mystery Boxes: go() se disparaba por TIEMPO
         (requestIdleCallback / 800 ms) con play() y preload='auto' estuviera
         donde estuviera, y el guard  if(!started) return  descartaba justo el
         primer aviso de "fuera de pantalla". El video quedaba sonando muy por
         debajo del viewport y peleando con el controlador global.
         Ahora el unico dueno del play / pause / preload es el controlador unico
         de assets/47x.js. Aqui queda solo el fundido. */
      v.addEventListener('playing',function(){ v.classList.add('is-on'); });
      v.addEventListener('pause',function(){ v.classList.remove('is-on'); });
    }
  }

  /* flechas del carrusel */
  var rail=root.querySelector('[data-mj47h-rail]');
  var prev=root.querySelector('[data-mj47h-prev]');
  var next=root.querySelector('[data-mj47h-next]');
  if(rail&&prev&&next){
    var step=function(){ var i=rail.querySelector('.mj47h__item'); return i ? i.offsetWidth+16 : 240; };
    prev.addEventListener('click',function(){ rail.scrollBy({left:-step()*2,behavior:'smooth'}); });
    next.addEventListener('click',function(){ rail.scrollBy({left: step()*2,behavior:'smooth'}); });
    var sync=function(){
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    rail.addEventListener('scroll',sync,{passive:true}); sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-one-piece-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-op47h]'); if(!root||root.__op47h) return; root.__op47h=1;

  /* fondo en video · nunca compite con el LCP */
  var v=root.querySelector('[data-op47h-vid]');
  if(v){
    var deskOnly=v.getAttribute('data-deskonly')==='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduce||(deskOnly&&window.matchMedia&&window.matchMedia('(max-width:899px)').matches)){
      v.removeAttribute('src'); v.innerHTML='';
    } else {
      /* 47X · esta seccion ya NO arranca el fondo por su cuenta (3-sep-2026).
         Mismo patron que traia Mystery Boxes: go() se disparaba por TIEMPO
         (requestIdleCallback / 800 ms) con play() y preload='auto' estuviera
         donde estuviera, y el guard  if(!started) return  descartaba justo el
         primer aviso de "fuera de pantalla". El video quedaba sonando muy por
         debajo del viewport y peleando con el controlador global.
         Ahora el unico dueno del play / pause / preload es el controlador unico
         de assets/47x.js. Aqui queda solo el fundido. */
      v.addEventListener('playing',function(){ v.classList.add('is-on'); });
      v.addEventListener('pause',function(){ v.classList.remove('is-on'); });
    }
  }

  /* flechas del carrusel */
  var rail=root.querySelector('[data-op47h-rail]');
  var prev=root.querySelector('[data-op47h-prev]');
  var next=root.querySelector('[data-op47h-next]');
  if(rail&&prev&&next){
    var step=function(){ var i=rail.querySelector('.op47h__item'); return i ? i.offsetWidth+16 : 240; };
    prev.addEventListener('click',function(){ rail.scrollBy({left:-step()*2,behavior:'smooth'}); });
    next.addEventListener('click',function(){ rail.scrollBy({left: step()*2,behavior:'smooth'}); });
    var sync=function(){
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    rail.addEventListener('scroll',sync,{passive:true}); sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdc-anime-47x"] && !Shopify.designMode) return;
  try {
    
/* Video de fondo del hero: preload="none" y solo corre mientras el hero se ve.
   Nunca se oculta por JS — si no arranca, queda la foto/poster, nunca un hueco. */
(function(){
  function boot(){
    var v=document.querySelector('[data-pdca-bgvid]'); if(!v) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    if(!('IntersectionObserver' in window)){ return; }
    var io=new IntersectionObserver(function(en){
      en.forEach(function(x){
        if(x.isIntersecting){
          if(!v.__on){ v.__on=1; v.preload='auto'; try{v.load();}catch(e){} }
          var p=v.play&&v.play(); if(p&&p.catch) p.catch(function(){});
        } else if(v.__on){ v.pause&&v.pause(); }
      });
    },{threshold:.1});
    io.observe(v);
  }
  (document.readyState==='loading')?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
})();

(function(){
  var root=document.querySelector('[data-pdca47]'); if(!root||root.__pdca) return; root.__pdca=1;
  if(root.dataset.promo!=='1') return;

  var META=parseInt(root.dataset.meta,10)||3;
  var elig=[];
  try{ elig=JSON.parse((root.querySelector('[data-pdca-elegibles]')||{}).textContent||'[]')||[]; }catch(e){}
  var eligSet={}; elig.forEach(function(id){ eligSet[String(id)]=1; });

  var box=root.querySelector('[data-pdca-promo]');
  var nEl=root.querySelector('[data-pdca-count]');
  var fEl=root.querySelector('[data-pdca-fill]');
  var mEl=root.querySelector('[data-pdca-msg]');
  var sticky=document.querySelector('[data-pdca-sticky]');
  var sN=document.querySelector('[data-pdca-stickyn]');
  var sMsg=document.querySelector('[data-pdca-stickymsg]');
  var sBtn=document.querySelector('[data-pdca-stickybtn]');

  /* Marca en cada card si participa o no. Nunca se promete lo que no aplica. */
  root.querySelectorAll('[data-pdca-cell]').forEach(function(cell){
    var f=cell.querySelector('[data-pdca-flag]'); if(!f) return;
    var pr=cell.querySelector('[data-pdca-price]');
    if(eligSet[cell.dataset.productId]){
      f.textContent='CUENTA PARA EL 20%'; f.classList.add('is-in');
      if(pr) pr.hidden=false;
    } else {
      f.textContent='NO ENTRA EN ESTA PROMO';
    }
    f.hidden=false;
  });

  /* El conteo sale del CARRITO REAL, no de clics. Si Shopify no lo cuenta, aquí tampoco. */
  function paint(n){
    var done=n>=META;
    if(nEl) nEl.textContent=n;
    if(fEl) fEl.style.width=Math.min(100,(n/META)*100)+'%';
    if(box) box.classList.toggle('is-done',done);
    if(mEl) mEl.textContent = done
      ? 'Listo · el 20% ya está aplicado en tu bolsa'
      : (n===0 ? 'El descuento se aplica solo al llegar a ' + META + ' piezas participantes'
               : 'Te falta' + ((META-n)===1 ? ' 1 pieza' : 'n ' + (META-n) + ' piezas') + ' para el 20%');
    if(sN) sN.textContent=n;
    if(sMsg) sMsg.textContent = done ? '20% aplicado en tu bolsa' : 'Agrega ' + META + ' y baja 20% c/u';
    if(sBtn) sBtn.hidden = n===0;
    if(sticky) sticky.classList.toggle('is-show', n>0);
  }

  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        var n=0;
        (c.items||[]).forEach(function(i){
          if(eligSet[String(i.product_id)]) n+=(i.quantity||0);
        });
        paint(n);
      }).catch(function(){});
  }

  refresh();
  /* Se recalcula cuando algo entra a la bolsa, sin sondear en bucle. */
  ['cart47:updated','cart:updated','cart47:open'].forEach(function(ev){
    document.addEventListener(ev,refresh);
    window.addEventListener(ev,refresh);
  });
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-card47-buy]')) setTimeout(refresh,700);
  });
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-mystery-ds-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-mysx]'); if(!root||root.__mbx) return; root.__mbx=1;

  /* video de fondo: nunca compite con el LCP.
     preload="none" + arranque tras window.load + solo mientras es visible. */
  var bgv=root.querySelector('[data-mysx-bgvid]');
  if(bgv){
    var deskOnly=bgv.getAttribute('data-deskonly')==='1';
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    /* Este archivo no tiene version ligera en Shopify: se sirve HD-1080. En
       ahorro de datos o 2G ni se descarga, que es lo que mas se agradece. */
    var conx=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
    var ahorro=!!(conx&&(conx.saveData||/(^|-)2g$/.test(conx.effectiveType||'')));
    var skip=reduce||ahorro||(deskOnly&&window.matchMedia&&window.matchMedia('(max-width:899px)').matches);
    if(skip){ bgv.removeAttribute('src'); bgv.innerHTML=''; }
    else{
      /* 47X · 4-sep-2026: aqui vivia el MISMO arranque por reloj que traia
         Mystery Boxes en el home: kick() -> requestIdleCallback/600ms -> start(),
         con play() y preload='auto' estuviera donde estuviera, y un observador
         cuyo guard  if(!started) return  descartaba justo el primer aviso de
         "fuera de pantalla". El video quedaba sonando fuera del viewport.
         El play / pause / preload lo lleva ahora el controlador global de
         assets/47x.js. Aqui queda solo el fundido. No se quito el video. */
      bgv.addEventListener('playing',function(){ bgv.classList.add('is-on'); });
      bgv.addEventListener('pause',function(){ bgv.classList.remove('is-on'); });
    }
  }

  /* galería */
  var main=root.querySelector('[data-mysx-main] .mysx47__mainimg');
  root.querySelectorAll('[data-mysx-thumbs] .mysx47__thumb').forEach(function(b){
    b.addEventListener('click',function(){
      if(main&&b.dataset.src){ main.src=b.dataset.src; main.removeAttribute('srcset'); }
      root.querySelectorAll('.mysx47__thumb').forEach(function(x){ x.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });

  /* CTA bloqueado hasta elegir talla válida */
  var form=root.querySelector('#mysx47-form');
  var cta=root.querySelector('[data-mysx-buy]');
  var ctaTxt=root.querySelector('[data-mysx-ctatext]');
  var ctaFull=root.querySelector('[data-mysx-ctafull]');
  var stickyBtn=root.querySelector('[data-mysx-stickybtn]');
  var sizes=root.querySelector('[data-mysx-sizes]');

  function unlock(){
    if(!cta) return;
    cta.disabled=false; cta.removeAttribute('aria-disabled');
    if(ctaTxt&&ctaFull) ctaTxt.textContent=ctaFull.textContent;
    if(stickyBtn) stickyBtn.disabled=false;
  }
  if(sizes){
    if(stickyBtn) stickyBtn.disabled=true;
    sizes.addEventListener('change',function(e){ if(e.target&&e.target.name==='id') unlock(); });
    /* si el navegador restauró una selección (bfcache/back) */
    if(sizes.querySelector('input[name="id"]:checked')) unlock();
  }

  /* sin talla → scroll al selector + flash, nunca submit vacío */
  function guard(ev){
    if(!sizes) return true;
    if(sizes.querySelector('input[name="id"]:checked')) return true;
    ev.preventDefault();
    sizes.scrollIntoView({behavior:'smooth',block:'center'});
    sizes.animate?sizes.animate([{opacity:1},{opacity:.35},{opacity:1}],{duration:520,iterations:2}):null;
    return false;
  }
  if(form) form.addEventListener('submit',guard);

  /* CTA final → scroll al form */
  var st=root.querySelector('[data-mysx-scrolltop]');
  if(st){ st.addEventListener('click',function(e){ e.preventDefault(); (form||root).scrollIntoView({behavior:'smooth',block:'center'}); }); }

  /* sticky: aparece al salir el CTA principal del viewport */
  var sticky=root.querySelector('[data-mysx-sticky]');
  if(sticky&&cta&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){
      en.forEach(function(x){
        sticky.classList.toggle('is-show', !x.isIntersecting);
        sticky.setAttribute('aria-hidden', x.isIntersecting?'true':'false');
      });
    },{rootMargin:'0px 0px -20% 0px'});
    io.observe(cta);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-preventa-demon-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-dspdp]'); if(!root||root.__init) return; root.__init=1;
  /* galería */
  var main=root.querySelector('[data-dspdp-main] .dspdp47__mainimg');
  root.querySelectorAll('[data-dspdp-thumbs] .dspdp47__thumb').forEach(function(b){
    b.addEventListener('click',function(){ if(main&&b.dataset.src){ main.src=b.dataset.src; } root.querySelectorAll('.dspdp47__thumb').forEach(function(x){x.classList.remove('is-active');}); b.classList.add('is-active'); });
  });
  /* CTA final → scroll al form */
  var st=root.querySelector('[data-dspdp-scrolltop]');
  if(st){ st.addEventListener('click',function(e){ e.preventDefault(); var f=root.querySelector('.dspdp47__form'); (f||root).scrollIntoView({behavior:'smooth',block:'center'}); }); }
  /* video: play/pause según visibilidad (perf · sin autoplay que bloquee LCP) */
  var vid=root.querySelector('[data-dspdp-video]');
  if(vid && 'IntersectionObserver' in window){
    var vio=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ vid.play&&vid.play().catch(function(){}); } else { vid.pause&&vid.pause(); } }); },{threshold:.35});
    vio.observe(vid);
  }
  /* STICKY ATC: aparece cuando el CTA principal sale del viewport */
  var sticky=root.querySelector('[data-dspdp-sticky]');
  var buy=root.querySelector('[data-dspdp-buy]');
  if(sticky && buy && 'IntersectionObserver' in window){
    var sio=new IntersectionObserver(function(en){ en.forEach(function(x){ sticky.classList.toggle('is-show', !x.isIntersecting); sticky.setAttribute('aria-hidden', x.isIntersecting?'true':'false'); }); },{rootMargin:'0px 0px -20% 0px'});
    sio.observe(buy);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-fam47-47x"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-rev47]'); if(!root) return;
  var form = root.querySelector('[data-rev47-form]') || root.querySelector('form');
  var grid = root.querySelector('[data-rev47-grid]');
  var okMsg = root.querySelector('[data-rev47-ok]');
  var empty = root.querySelector('[data-rev47-empty]');

  /* ---- censura de groserías en las reseñas mostradas (por palabra) ---- */
  var BAD = ['pendejo','pendejos','pendeja','pendejas','cabron','cabrón','cabrones','mierda','verga','vergas','puta','putas','puto','putos','chinga','chingada','chingado','chingar','chingas','pinche','pinches','coño','joto','jotos','marica','maricon','maricón','culero','culeros','mamada','mamadas','mamon','mamón','estupido','estúpido','idiota','imbecil','imbécil','zorra','perra','malparido','jueputa','hijueputa','pelotudo','boludo','fuck','fucking','shit','bitch','asshole','dick','cunt','wtf'];
  var SET = {}; BAD.forEach(function(w){ SET[w] = 1; });
  function censor(t){
    return t.split(/(\s+)/).map(function(tk){
      var w = tk.toLowerCase().replace(/[^a-záéíóúñü]/gi,'');
      return (w && SET[w]) ? '●●●' : tk;
    }).join('');
  }
  root.querySelectorAll('[data-rev47-text]').forEach(function(el){
    var c = censor(el.textContent); if(c !== el.textContent) el.textContent = c;
  });

  /* ---- CARRUSEL · tandas de 4, rota cada 5s (pausa al hover) ---- */
  var reduce = false; try{ reduce = matchMedia('(prefers-reduced-motion:reduce)').matches; }catch(e){}
  var carTimer = null;
  function cards(){ return grid ? Array.prototype.slice.call(grid.querySelectorAll('.rev47__card')) : []; }
  function initCarousel(){
    if(carTimer){ clearInterval(carTimer); carTimer = null; }
    var cs = cards();
    if(empty){ empty.hidden = cs.length > 0; }
    if(!grid) return;
    if(cs.length <= 4 || reduce){ cs.forEach(function(c){ c.style.display = ''; }); return; }
    var pages = Math.ceil(cs.length / 4), pg = 0;
    function show(p){ cs.forEach(function(c,i){ c.style.display = (Math.floor(i/4) === p) ? '' : 'none'; }); }
    show(0);
    carTimer = setInterval(function(){
      grid.style.opacity = '0';
      setTimeout(function(){ pg = (pg + 1) % pages; show(pg); grid.style.opacity = ''; }, 350);
    }, 5000);
  }
  if(grid){
    grid.addEventListener('mouseenter', function(){ if(carTimer){ clearInterval(carTimer); carTimer = null; } });
    grid.addEventListener('mouseleave', function(){ initCarousel(); });
  }
  initCarousel();

  if(!form) return;
  var body = form.querySelector('[data-rev47-body]');
  var TOKENS = ['⟦r1⟧','⟦r2⟧','⟦r3⟧','⟦r4⟧','⟦r5⟧'];
  function stripToken(v){ TOKENS.forEach(function(t){ v = v.split(t).join(''); }); return v.replace(/^\s+/,''); }

  form.addEventListener('submit', function(e){
    var r = root.querySelector('[name="fam47_rating"]:checked');
    var rating = r ? parseInt(r.value,10) : 5;
    if(body){ body.value = '⟦r'+rating+'⟧ ' + stripToken(body.value); }
    /* correo oculto autorrelleno (Shopify lo exige; no se pide al usuario ni se publica) */
    var emailEl = form.querySelector('[data-rev47-email]');
    if(emailEl){ emailEl.value = 'resenas+' + Date.now().toString(36) + Math.random().toString(36).slice(2,6) + '@fam47.mx'; }

    /* AJAX: no sacar al usuario del home */
    if(window.fetch && form.action){
      e.preventDefault();
      var fd = new FormData(form);
      var authorEl = form.querySelector('[name="comment[author]"]');
      var author = authorEl ? authorEl.value.trim() : '';
      var reviewText = body ? stripToken(body.value) : '';
      var btn = form.querySelector('.rev47__submit');
      if(btn){ btn.disabled = true; btn.style.opacity = '.6'; }
      fetch(form.action, { method:'POST', body: fd, headers:{ 'X-Requested-With':'XMLHttpRequest' } })
        .then(function(){
          if(okMsg){ okMsg.hidden = false; }
          /* agrega la reseña al muro al instante SOLO si es 5★ */
          if(rating === 5 && grid && reviewText){
            var li = document.createElement('li');
            li.className = 'rev47__card'; li.setAttribute('data-rev47-review','');
            var s = document.createElement('span'); s.className='rev47__card-stars'; s.textContent='★★★★★';
            var p = document.createElement('p'); p.className='rev47__card-body'; p.textContent = censor(reviewText);
            var a = document.createElement('span'); a.className='rev47__card-author'; a.textContent = '— ' + (author || 'FAM47');
            li.appendChild(s); li.appendChild(p); li.appendChild(a);
            grid.insertBefore(li, grid.firstChild);
            initCarousel();
          }
          form.reset();
          var d5 = document.getElementById(form.querySelector('[name="fam47_rating"][value="5"]').id); if(d5) d5.checked = true;
          if(btn){ btn.disabled = false; btn.style.opacity = ''; }
        })
        .catch(function(){
          if(btn){ btn.disabled = false; btn.style.opacity=''; }
          form.submit(); /* fallback: envío normal */
        });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-movimiento-47x"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.vmov47--autoplay');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (sec) {
    var vids = sec.querySelectorAll('.vmov47__video');
    if (!vids.length) return;

    // Movimiento reducido: no reproducir, dejar poster.
    if (reduce) {
      vids.forEach(function (v) { try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {} });
      return;
    }

    if (!('IntersectionObserver' in window)) return; // el autoplay nativo se encarga

    // Pausa fuera de pantalla (batería/rendimiento); reanuda al entrar.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.2 });

    vids.forEach(function (v) { io.observe(v); });
  });

  // CTA con ancla → scroll suave + foco al correo del PASE FAM47
  document.querySelectorAll('[data-vmov-cta]').forEach(function (cta) {
    cta.addEventListener('click', function (ev) {
      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      ev.preventDefault();
      var reduceM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceM ? 'auto' : 'smooth', block: 'center' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, reduceM ? 0 : 600);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
